import React, { useState } from "react";
import SurveyFormItem from "../../Components/SurveyFormItem/SurveyFormItem";
import "text-security/text-security.css"
import SurveyInput from "../../Components/SurveyInput/SurveyInput";
import { format24HTimeToTimeAnswer, formatTimeAnswerToISOTime } from "../../Util/timeHelpers";
import { SurveyQuestionProps } from "../../Components/SurveyQuestion/SurveyQuestion";
import useTranslate from "../../../../hooks/useTranslate";
import { QuestionResultModel } from "../../../../types/SurveyResult";

export default function (props: SurveyQuestionProps) {
    let defaultPlaceholder = useTranslate(["default-time-placeholder"])["default-time-placeholder"];
    let currentResult = props.result as QuestionResultModel;
    const currentAnswer = currentResult.Answers[0] || "";

    function answerChanged(answer: string) {
        const formattedAnswer = format24HTimeToTimeAnswer(answer);
        props.onResultChange({ ...props.result, Answers: [formattedAnswer] } as QuestionResultModel);
    }

    let time = currentAnswer ? formatTimeAnswerToISOTime(currentAnswer) : "";

    return <SurveyFormItem
        topBorder
        bottomBorder
        label={props.label}
        labelFor={props.inputIdForLabel}
        labelPosition={props.labelPosition}
        variant={props.variant}
        useFieldsetFormat={props.useFieldsetFormat}
        index={props.index}>
        <SurveyInput id={props.inputIdForLabel}
            value={time}
            type="time"
            placeholder={props.placeholder || defaultPlaceholder}
            onChange={(e) => answerChanged(e.target.value)}
            onEnterPressed={props.onEnterPressed}
            variant={props.variant} />
    </SurveyFormItem>
}